import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { IDamageReason, IDamageReasonProps, IDamageReasonStates } from "./interfaces";

export class DamageReason extends EntityManager<IDamageReason, IDamageReasonProps, IDamageReasonStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "DamageReason",
            title: "دلایل خسارت",
            Properties: [
                {
                    title: "دلیل",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا دلیل را وارد نمایید' }]
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }]
                }
            ]
        };
    }
}